var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareO(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7366 8.495L19.7366 10.5648C19.7366 10.7264 19.8728 10.861 20.0361 10.861L26.3123 10.861L26.3123 29.3416L5.68773 29.3416L5.68773 10.8572L11.9639 10.8572C12.1272 10.8572 12.2634 10.7225 12.2634 10.5609L12.2634 8.49115C12.2634 8.32957 12.1311 8.19492 11.9639 8.19492L4.19411 8.19492C3.53288 8.19492 3 8.72198 3 9.37601L3 30.8189C3 31.4729 3.53288 32 4.19412 32L27.8059 32C28.4671 32 29 31.4729 29 30.8189L29 9.37985C29 8.72583 28.4671 8.19877 27.8059 8.19877L20.0361 8.19877C19.8689 8.19877 19.7366 8.33342 19.7366 8.495ZM14.5997 18.1575L14.5997 6.07737L11.6436 6.07737C11.383 6.07737 11.2352 5.77729 11.3986 5.57724L15.755 0.118087C15.7841 0.0813021 15.8213 0.0515513 15.8637 0.0310911C15.9062 0.0106329 15.9528 1.34116e-06 16 1.3391e-06C16.0472 1.33704e-06 16.0938 0.0106329 16.1363 0.0310911C16.1787 0.0515512 16.2159 0.0813021 16.245 0.118087L20.6014 5.57724C20.7648 5.78114 20.617 6.07737 20.3564 6.07737L17.4003 6.07737L17.4003 18.1575C17.4003 18.3268 17.2602 18.4653 17.0891 18.4653L14.9109 18.4653C14.7398 18.4653 14.5997 18.3268 14.5997 18.1575Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareO);
export default __webpack_public_path__ + "static/media/share-o.7de965a6a5f4c861948bcbdf3c18333c.svg";
export { ForwardRef as ReactComponent };